<div class="docs-section" id="account-scoped-filters">
  <div class="docs-section__head">
    <h1 class="docs-h1">Account-scoped filters</h1>
  </div>
  <p class="docs-subtitle">
    Filters marked <span class="endpoint-badge endpoint-badge--opt">account-scoped</span> name things that live in
    your Cikisi account knowledge bases, tags, saved searches, sources. They mean nothing without a linked
    Cikisi client, and for callers without one they are ignored rather than refused: you have not asked for
    something out of reach, you have asked for something that does not apply.
  </p>
  <p class="docs-subtitle">Everything else dates, domains, language, geography behaves the same either way.</p>
  <p class="docs-subtitle">
    See any endpoint's own <a class="link" routerLink="/docs/api-reference">reference page</a> for which of its
    request parameters carry this badge.
  </p>
</div>
